var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.items,"rules":_vm.rules,"item-text":"tarafAdi","item-value":"guncelKisiKurumId","label":_vm.label? _vm.label : 'Alacaklı',"outlined":"","dense":""},on:{"input":_vm.onAlacakliChange},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }